/* Product mock-ups for the six capability cards. Ported 1:1 from the approved
   design export (colours are part of the illustration, not site tokens). */

export function MockIntent() {
  return (
    <div style={{ borderRadius: "16px", background: "rgba(255,255,255,0.86)", border: "1px solid rgba(27,37,66,0.07)", boxShadow: "0 10px 26px -18px rgba(27,37,66,0.4)", padding: "16px" }}>
      <div style={{ padding: "11px 13px", borderRadius: "12px 12px 12px 4px", background: "#F3F6FB", border: "1px solid rgba(27,37,66,0.07)", fontSize: "13px", lineHeight: "1.45", fontWeight: "500", color: "#1B2542" }}>
        &quot;Third time I&apos;m asking about my refund.&quot;
      </div>
      <div style={{ display: "flex", flexWrap: "wrap", gap: "6px", marginTop: "12px" }}>
        <span style={{ padding: "5px 10px", borderRadius: "99px", fontSize: "11px", fontWeight: "700", color: "#0163FF", background: "rgba(1,99,255,0.10)", border: "1px solid rgba(1,99,255,0.22)" }}>
          Complaint
        </span>
        <span style={{ padding: "5px 10px", borderRadius: "99px", fontSize: "11px", fontWeight: "700", color: "#E11D48", background: "rgba(225,29,72,0.10)", border: "1px solid rgba(225,29,72,0.22)" }}>
          Frustration 0.82
        </span>
        <span style={{ padding: "5px 10px", borderRadius: "99px", fontSize: "11px", fontWeight: "700", color: "#B45309", background: "rgba(217,119,6,0.12)", border: "1px solid rgba(217,119,6,0.26)" }}>
          Urgency high
        </span>
      </div>
      <div style={{ marginTop: "14px", paddingTop: "14px", borderTop: "1px dashed rgba(27,37,66,0.12)" }}>
        <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", gap: "10px" }}>
          <span style={{ fontSize: "11px", fontWeight: "700", letterSpacing: "0.12em", color: "#8A93A6" }}>
            DRAFT SHIFTS TO
          </span>
          <span style={{ fontSize: "12px", fontWeight: "700", color: "#1B2542" }}>
            Apologise · act now
          </span>
        </div>
        <div style={{ display: "flex", gap: "6px", marginTop: "10px" }}>
          <span style={{ flex: "1", height: "6px", borderRadius: "99px", background: "#E11D48" }} />
          <span style={{ flex: "1", height: "6px", borderRadius: "99px", background: "#F59E0B" }} />
          <span style={{ flex: "1", height: "6px", borderRadius: "99px", background: "rgba(27,37,66,0.1)" }} />
          <span style={{ flex: "1", height: "6px", borderRadius: "99px", background: "rgba(27,37,66,0.1)" }} />
        </div>
      </div>
    </div>
  );
}

export function MockKnowledge() {
  return (
    <div style={{ borderRadius: "16px", background: "rgba(255,255,255,0.86)", border: "1px solid rgba(27,37,66,0.07)", boxShadow: "0 10px 26px -18px rgba(27,37,66,0.4)", padding: "16px" }}>
      <div style={{ display: "grid", gap: "7px" }}>
        <div style={{ display: "flex", alignItems: "center", gap: "9px", padding: "9px 11px", borderRadius: "9px", background: "#F3F6FB", border: "1px solid rgba(27,37,66,0.07)" }}>
          <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="#0163FF" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round">
            <path d="M6 3h8l4 4v14H6z" />
            <path d="M14 3v4h4" />
          </svg>
          <span style={{ fontSize: "12px", fontWeight: "600", color: "#1B2542" }}>
            Refund SLA · 7 days
          </span>
        </div>
        <div style={{ display: "flex", alignItems: "center", gap: "9px", padding: "9px 11px", borderRadius: "9px", background: "#F3F6FB", border: "1px solid rgba(27,37,66,0.07)" }}>
          <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="#0163FF" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round">
            <path d="M6 3h8l4 4v14H6z" />
            <path d="M14 3v4h4" />
          </svg>
          <span style={{ fontSize: "12px", fontWeight: "600", color: "#1B2542" }}>
            Verification process
          </span>
        </div>
      </div>
      <div style={{ display: "flex", alignItems: "center", gap: "8px", margin: "12px 0" }}>
        <span style={{ flex: "1", height: "1px", background: "rgba(27,37,66,0.12)" }} />
        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#0163FF" strokeWidth="2.6" strokeLinecap="round" strokeLinejoin="round">
          <path d="M12 5v14" />
          <path d="m5 12 7 7 7-7" />
        </svg>
        <span style={{ flex: "1", height: "1px", background: "rgba(27,37,66,0.12)" }} />
      </div>
      <div style={{ padding: "12px 13px", borderRadius: "10px", background: "#fff", border: "1px solid rgba(1,99,255,0.24)", fontSize: "13px", lineHeight: "1.5", color: "#1B2542" }}>
        Your refund is stuck at verification. I have pushed it through, confirmation lands by
        <span style={{ fontWeight: "700", color: "#0163FF" }}>
          tomorrow evening
        </span>
        .
      </div>
      <div style={{ display: "flex", alignItems: "center", gap: "7px", marginTop: "11px" }}>
        <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="#12A150" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round">
          <path d="m5 13 4 4 10-10" />
        </svg>
        <span style={{ fontSize: "11px", fontWeight: "700", color: "#12A150" }}>
          2 sources cited
        </span>
      </div>
    </div>
  );
}

export function MockVoice() {
  return (
    <div style={{ borderRadius: "16px", background: "rgba(255,255,255,0.86)", border: "1px solid rgba(27,37,66,0.07)", boxShadow: "0 10px 26px -18px rgba(27,37,66,0.4)", padding: "16px" }}>
      <div style={{ fontSize: "11px", fontWeight: "700", letterSpacing: "0.14em", color: "#8A93A6" }}>
        TONE GUIDE
      </div>
      <div style={{ display: "flex", flexWrap: "wrap", gap: "6px", marginTop: "11px" }}>
        <span style={{ padding: "5px 10px", borderRadius: "99px", fontSize: "11px", fontWeight: "700", color: "#0163FF", background: "rgba(1,99,255,0.10)", border: "1px solid rgba(1,99,255,0.22)" }}>
          Warm
        </span>
        <span style={{ padding: "5px 10px", borderRadius: "99px", fontSize: "11px", fontWeight: "700", color: "#0163FF", background: "rgba(1,99,255,0.10)", border: "1px solid rgba(1,99,255,0.22)" }}>
          Direct
        </span>
        <span style={{ padding: "5px 10px", borderRadius: "99px", fontSize: "11px", fontWeight: "700", color: "#0163FF", background: "rgba(1,99,255,0.10)", border: "1px solid rgba(1,99,255,0.22)" }}>
          No jargon
        </span>
      </div>
      <div style={{ display: "grid", gap: "7px", marginTop: "14px", paddingTop: "14px", borderTop: "1px dashed rgba(27,37,66,0.12)" }}>
        <div style={{ display: "flex", alignItems: "center", gap: "9px", padding: "9px 11px", borderRadius: "9px", background: "rgba(18,161,80,0.08)", border: "1px solid rgba(18,161,80,0.24)" }}>
          <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="#12A150" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round">
            <path d="m5 13 4 4 10-10" />
          </svg>
          <span style={{ fontSize: "12px", fontWeight: "600", color: "#1B2542" }}>
            &quot;You shouldn&apos;t have had to ask&quot;
          </span>
        </div>
        <div style={{ display: "flex", alignItems: "center", gap: "9px", padding: "9px 11px", borderRadius: "9px", background: "rgba(225,29,72,0.07)", border: "1px solid rgba(225,29,72,0.2)" }}>
          <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="#E11D48" strokeWidth="2.8" strokeLinecap="round">
            <path d="M6 6l12 12" />
            <path d="M18 6 6 18" />
          </svg>
          <span style={{ fontSize: "12px", color: "#8A93A6", textDecoration: "line-through" }}>
            &quot;As per our policy…&quot;
          </span>
        </div>
      </div>
      <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", gap: "10px", marginTop: "13px" }}>
        <span style={{ fontSize: "11px", fontWeight: "700", letterSpacing: "0.12em", color: "#8A93A6" }}>
          ON-BRAND SCORE
        </span>
        <span style={{ fontSize: "13px", fontWeight: "800", letterSpacing: "-0.02em", color: "#0163FF" }}>
          96%
        </span>
      </div>
    </div>
  );
}

export function MockChannel() {
  return (
    <div style={{ borderRadius: "16px", background: "rgba(255,255,255,0.86)", border: "1px solid rgba(27,37,66,0.07)", boxShadow: "0 10px 26px -18px rgba(27,37,66,0.4)", padding: "16px", display: "grid", gap: "9px" }}>
      <div style={{ padding: "10px 12px", borderRadius: "10px", background: "#F3F6FB", border: "1px solid rgba(27,37,66,0.07)" }}>
        <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", gap: "8px" }}>
          <span style={{ fontSize: "11px", fontWeight: "800", letterSpacing: "0.08em", color: "#1B2542" }}>
            X REPLY
          </span>
          <span style={{ fontSize: "10px", fontWeight: "700", color: "#8A93A6" }}>
            180 chars
          </span>
        </div>
        <div style={{ display: "grid", gap: "5px", marginTop: "8px" }}>
          <span style={{ height: "5px", borderRadius: "99px", background: "rgba(1,99,255,0.5)", width: "84%" }} />
          <span style={{ height: "5px", borderRadius: "99px", background: "rgba(27,37,66,0.14)", width: "52%" }} />
        </div>
      </div>
      <div style={{ padding: "10px 12px", borderRadius: "10px", background: "#F3F6FB", border: "1px solid rgba(27,37,66,0.07)" }}>
        <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", gap: "8px" }}>
          <span style={{ fontSize: "11px", fontWeight: "800", letterSpacing: "0.08em", color: "#1B2542" }}>
            INSTAGRAM DM
          </span>
          <span style={{ fontSize: "10px", fontWeight: "700", color: "#8A93A6" }}>
            2 lines
          </span>
        </div>
        <div style={{ display: "grid", gap: "5px", marginTop: "8px" }}>
          <span style={{ height: "5px", borderRadius: "99px", background: "rgba(139,92,246,0.5)", width: "72%" }} />
          <span style={{ height: "5px", borderRadius: "99px", background: "rgba(27,37,66,0.14)", width: "44%" }} />
        </div>
      </div>
      <div style={{ padding: "10px 12px", borderRadius: "10px", background: "#fff", border: "1px solid rgba(1,99,255,0.24)" }}>
        <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", gap: "8px" }}>
          <span style={{ fontSize: "11px", fontWeight: "800", letterSpacing: "0.08em", color: "#1B2542" }}>
            SUPPORT EMAIL
          </span>
          <span style={{ fontSize: "10px", fontWeight: "700", color: "#0163FF" }}>
            Formal
          </span>
        </div>
        <div style={{ display: "grid", gap: "5px", marginTop: "8px" }}>
          <span style={{ height: "5px", borderRadius: "99px", background: "rgba(1,99,255,0.5)", width: "96%" }} />
          <span style={{ height: "5px", borderRadius: "99px", background: "rgba(1,99,255,0.35)", width: "88%" }} />
          <span style={{ height: "5px", borderRadius: "99px", background: "rgba(27,37,66,0.14)", width: "66%" }} />
        </div>
      </div>
    </div>
  );
}

export function MockHistory() {
  return (
    <div style={{ borderRadius: "16px", background: "rgba(255,255,255,0.86)", border: "1px solid rgba(27,37,66,0.07)", boxShadow: "0 10px 26px -18px rgba(27,37,66,0.4)", padding: "16px" }}>
      <div style={{ display: "grid", gap: "0" }}>
        <div style={{ display: "flex", gap: "11px" }}>
          <div style={{ display: "flex", flexDirection: "column", alignItems: "center", flex: "0 0 10px" }}>
            <span style={{ width: "9px", height: "9px", borderRadius: "99px", background: "rgba(27,37,66,0.22)", marginTop: "4px" }} />
            <span style={{ flex: "1", width: "2px", background: "rgba(27,37,66,0.12)" }} />
          </div>
          <div style={{ paddingBottom: "13px" }}>
            <div style={{ fontSize: "12px", fontWeight: "700", color: "#1B2542" }}>
              Ticket #4471 · 12 days ago
            </div>
            <div style={{ marginTop: "3px", fontSize: "12px", color: "#8A93A6" }}>
              Refund requested
            </div>
          </div>
        </div>
        <div style={{ display: "flex", gap: "11px" }}>
          <div style={{ display: "flex", flexDirection: "column", alignItems: "center", flex: "0 0 10px" }}>
            <span style={{ width: "9px", height: "9px", borderRadius: "99px", background: "rgba(27,37,66,0.22)", marginTop: "4px" }} />
            <span style={{ flex: "1", width: "2px", background: "rgba(27,37,66,0.12)" }} />
          </div>
          <div style={{ paddingBottom: "13px" }}>
            <div style={{ fontSize: "12px", fontWeight: "700", color: "#1B2542" }}>
              Follow-up · 5 days ago
            </div>
            <div style={{ marginTop: "3px", fontSize: "12px", color: "#8A93A6" }}>
              No response logged
            </div>
          </div>
        </div>
        <div style={{ display: "flex", gap: "11px" }}>
          <div style={{ display: "flex", flexDirection: "column", alignItems: "center", flex: "0 0 10px" }}>
            <span style={{ width: "9px", height: "9px", borderRadius: "99px", background: "#0163FF", marginTop: "4px", boxShadow: "0 0 0 4px rgba(1,99,255,0.16)" }} />
          </div>
          <div>
            <div style={{ fontSize: "12px", fontWeight: "700", color: "#0163FF" }}>
              Now · 4th contact
            </div>
            <div style={{ marginTop: "3px", fontSize: "12px", color: "#8A93A6" }}>
              Context carried into the draft
            </div>
          </div>
        </div>
      </div>
      <div style={{ marginTop: "14px", padding: "11px 12px", borderRadius: "10px", background: "#fff", border: "1px solid rgba(1,99,255,0.24)", fontSize: "12px", lineHeight: "1.5", color: "#1B2542" }}>
        &quot;You shouldn&apos;t have had to ask three times.&quot;
      </div>
    </div>
  );
}

export function MockHuman() {
  return (
    <div style={{ borderRadius: "16px", background: "rgba(255,255,255,0.86)", border: "1px solid rgba(27,37,66,0.07)", boxShadow: "0 10px 26px -18px rgba(27,37,66,0.4)", padding: "16px" }}>
      <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", gap: "10px" }}>
        <span style={{ fontSize: "11px", fontWeight: "700", letterSpacing: "0.14em", color: "#8A93A6" }}>
          SUGGESTED DRAFT
        </span>
        <span style={{ padding: "4px 9px", borderRadius: "99px", fontSize: "10px", fontWeight: "700", color: "#0163FF", background: "rgba(1,99,255,0.10)" }}>
          AGENT REVIEW
        </span>
      </div>
      <div style={{ marginTop: "12px", padding: "11px 12px", borderRadius: "10px", background: "#F3F6FB", border: "1px solid rgba(27,37,66,0.07)", fontSize: "12px", lineHeight: "1.55", color: "#1B2542" }}>
        Twelve days is far too long. I&apos;ve pushed your refund through and you&apos;ll have confirmation by tomorrow evening.
      </div>
      <div style={{ display: "flex", flexWrap: "wrap", gap: "6px", marginTop: "13px" }}>
        <span style={{ padding: "5px 10px", borderRadius: "8px", fontSize: "11px", fontWeight: "600", color: "#3B4657", background: "#fff", border: "1px solid rgba(27,37,66,0.12)" }}>
          Shorter
        </span>
        <span style={{ padding: "5px 10px", borderRadius: "8px", fontSize: "11px", fontWeight: "600", color: "#3B4657", background: "#fff", border: "1px solid rgba(27,37,66,0.12)" }}>
          Warmer
        </span>
        <span style={{ padding: "5px 10px", borderRadius: "8px", fontSize: "11px", fontWeight: "600", color: "#3B4657", background: "#fff", border: "1px solid rgba(27,37,66,0.12)" }}>
          Firmer
        </span>
        <span style={{ padding: "5px 10px", borderRadius: "8px", fontSize: "11px", fontWeight: "600", color: "#3B4657", background: "#fff", border: "1px solid rgba(27,37,66,0.12)" }}>
          More formal
        </span>
      </div>
      <div style={{ display: "flex", gap: "8px", marginTop: "14px", paddingTop: "14px", borderTop: "1px dashed rgba(27,37,66,0.12)" }}>
        <span style={{ flex: "1", textAlign: "center", padding: "9px 10px", borderRadius: "9px", fontSize: "12px", fontWeight: "700", color: "#fff", background: "linear-gradient(96deg, #0163FF 0%, #4B3CFF 100%)" }}>
          Send
        </span>
        <span style={{ flex: "1", textAlign: "center", padding: "9px 10px", borderRadius: "9px", fontSize: "12px", fontWeight: "700", color: "#3B4657", background: "#fff", border: "1px solid rgba(27,37,66,0.12)" }}>
          Edit
        </span>
        <span style={{ flex: "1", textAlign: "center", padding: "9px 10px", borderRadius: "9px", fontSize: "12px", fontWeight: "700", color: "#3B4657", background: "#fff", border: "1px solid rgba(27,37,66,0.12)" }}>
          Regenerate
        </span>
      </div>
    </div>
  );
}
